/* eslint-disable import/prefer-default-export */
import { easyPost } from './utils';

//  配置
export const getDeviceInfo = easyPost('platform.channel.data.report');
